var _path, _mask, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81344 3.79821L11.5062 1.79654L7.62955 0.437098C7.47455 0.382654 7.30455 0.38821 7.15344 0.45321L5.80288 1.02877C5.61844 1.1071 5.48066 1.26488 5.42677 1.45821C5.37344 1.65043 5.41011 1.85654 5.52788 2.01877L6.81344 3.79821Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    x: 0,
    y: 0,
    width: 21,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600098 0.61734H20.6001V14.0465H0.600098V0.61734Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5474 1.26432C20.1802 0.401541 17.9319 0.533763 17.0691 0.901541L4.78186 6.14154C3.30075 5.00876 3.76241 5.3621 2.70963 4.5571C2.5213 4.41321 2.27019 4.38154 2.05186 4.47487L0.999635 4.92321C0.827413 4.9971 0.694635 5.14099 0.634635 5.31765C0.574635 5.49543 0.593524 5.68987 0.685746 5.85265C1.56408 7.40098 1.12797 6.63265 2.7613 9.51321C3.06908 10.056 3.73463 10.281 4.30852 10.0365C5.39186 9.57432 4.07241 10.1371 8.97297 8.0471C9.37408 9.71765 9.05297 8.38098 10.293 13.5427C10.338 13.7304 10.4635 13.8893 10.6369 13.9765C10.8096 14.0632 11.0119 14.0699 11.1902 13.9938L12.5307 13.4221C12.7124 13.3443 12.8496 13.1893 12.9046 12.9999C14.6807 6.86598 14.4463 7.67654 15.0952 5.43599L18.4019 4.02599C19.2652 3.65765 20.9157 2.1271 20.5474 1.26432Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightIcon);
export default __webpack_public_path__ + "static/media/flight_icon.628d685ba425e2ffa8057d03b767f2fc.svg";
export { ForwardRef as ReactComponent };